
import {distinctUntilChanged} from 'rxjs/operators';
import { Injectable } from "@angular/core";
import { BehaviorSubject ,  Observable } from "rxjs";

@Injectable()
export class ConfigSearchService {
    private finalSearchResult: BehaviorSubject<Array<string>>;
    private showSearchResult: BehaviorSubject<boolean>;
    public isSearching: boolean = false;
    public isTreeToggle = false;

    constructor() {
        this.finalSearchResult = new BehaviorSubject([]);
        this.showSearchResult = new BehaviorSubject(false);
    }

    get finalResult(): Array<string> {
        return this.finalSearchResult.getValue();
    }

    set finalResult(result: Array<string>) {
        this.finalSearchResult.next(result);
    }

    public finalResultChanges(): Observable<Array<string>> {
        return this.finalSearchResult.asObservable().pipe(distinctUntilChanged());
    }

    get showSearch(): boolean {
        return this.showSearchResult.getValue();
    }

    set showSearch(result: boolean) {
        this.showSearchResult.next(result);
    }

    public showSearchChanges(): Observable<boolean> {
        return this.showSearchResult.asObservable().pipe(distinctUntilChanged());
    }
}